import React, { Component, useState } from 'react';

function VideoDemo({ demo }) {
  const [showVideo, setShowVideo] = useState(false);

  return (
    <div onClick={() => setShowVideo(true)} style={{ cursor: "pointer" }}>
      {!showVideo ? (
        <>
          <img
            className="portfolio-image"
            alt={demo.title}
            src={"images/portfolio/" + demo.image}
          />
          <div className="overlay">
            <div className="portfolio-item-meta">
              <h5>{demo.title}</h5>
              <p>{demo.category}</p>
            </div>
          </div>
          <div className="link-icon">
            <i className="fa fa-play"></i>
          </div>
        </>
      ) : (
        <iframe
          width="100%"
          height="315"
          src={demo.video + "?autoplay=1"}
          title={demo.title}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      )}
    </div>
  );
}

class Demo extends Component {
  render() {
    if (this.props.data) {
      var demos = this.props.data.demos.map(function (demo) {
        return (
          <div key={demo.title} className="columns portfolio-item">
            <div className="item-wrap">
              <VideoDemo demo={demo} />
            </div>
          </div>
        );
      });
    }

    return (
      <section id="portfolio">
        <div className="row demos">
          <div className="twelve columns collapsed">
            <h1>Project Demos</h1>
            <div id="portfolio-wrapper" className="bgrid-quarters s-bgrid-thirds cf">
              {demos}
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default Demo;
